import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RootScopeService } from '../../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../../core/rootscope-declare';

interface facilityOpHours {
  facilityHoursStart: number;
  facilityMinsStart: number;
  facilityHoursEnd: number;
  facilityMinsEnd: number;
  language: string;
}

@Component({
  selector: 'app-widget-step3',
  templateUrl: './widget-step3.component.html',
  styleUrls: ['./widget-step3.component.scss'],
})

export class WidgetStep3Component implements OnInit {
  rootScopeData: RootScopeDeclare;
  openTime: string;
  closeTime: string;
  widgetLanguage: string;
  step3data: { language: string; openTime: string; closeTime: string };

  @Output() step3details = new EventEmitter();
  @Input() totalFacilityOperatingHours: facilityOpHours;
  openFacTime: { facilityHours: number; facilityMins: number; };
  closeFacTime: { facilityHours: number; facilityMins: number; };
  language: string;
  openTimeDisableController: string = "";
  closeTimeDisableController: string = "";
  facilityOperationHourBefore: boolean = false;
  facilityOperationHourSame: boolean = false;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }
  ngOnInit(): void {
    //this.openFacTime={"facilityHours": this.totalFacilityOperatingHours.facilityHoursStart, "facilityMins": this.totalFacilityOperatingHours.facilityMinsStart};
    //this.closeFacTime={"facilityHours": this.totalFacilityOperatingHours.facilityHoursEnd, "facilityMins": this.totalFacilityOperatingHours.facilityMinsEnd};

    this.openFacTime = { facilityHours: 24, facilityMins: 0 };
    this.closeFacTime = { facilityHours: 23, facilityMins: 59 };

    if (
      this.totalFacilityOperatingHours.facilityHoursEnd == 24 || 
      (
        this.totalFacilityOperatingHours.facilityHoursStart == 0 && 
        this.totalFacilityOperatingHours.facilityHoursEnd == 23 && 
        this.totalFacilityOperatingHours.facilityMinsStart == 0 && 
        this.totalFacilityOperatingHours.facilityMinsEnd == 59 
      )
      ) {
      this.openTime = `24:00`;
      this.closeTime = `00:00`;
        setTimeout(() => {
          this.getCurrentOpenTime('99:99');
        },300)
    } else {
      this.openFacTime = {
        facilityHours: parseInt(this.totalFacilityOperatingHours.facilityHoursStart.toString(), 10),
        facilityMins: parseInt(this.totalFacilityOperatingHours.facilityMinsStart.toString(), 10),
      };
      this.closeFacTime = {
        facilityHours: parseInt(this.totalFacilityOperatingHours.facilityHoursEnd.toString(), 10),
        facilityMins: parseInt(this.totalFacilityOperatingHours.facilityMinsEnd.toString(), 10),
      };
      this.openTime = `${this.totalFacilityOperatingHours.facilityHoursStart}:${this.totalFacilityOperatingHours.facilityMinsStart}`;
      this.closeTime = `${this.totalFacilityOperatingHours.facilityHoursEnd}:${this.totalFacilityOperatingHours.facilityMinsEnd}`;
    }
    

    this.language = this.totalFacilityOperatingHours.language;
  }

  isAfter24Hr: boolean = false;
  getCurrentOpenTime(time: string) {
    if (time === "99:99") {
      this.openTime = "00:00";
      this.closeTime = "24:00";
      this.openTimeDisableController = 'mp';
      this.closeTimeDisableController = 'hmp';
      this.isAfter24Hr = true;
    } else {
      this.openTime = time;
      if (this.rootScopeData.deviceType === 'phone' && this.isAfter24Hr) {
        this.openFacTime = { facilityHours: 0, facilityMins: 0 };
        this.closeFacTime = { facilityHours: 23, facilityMins: 59 };
        this.isAfter24Hr = true;
      } else {
        this.closeTime = `${this.closeFacTime.facilityHours}:${this.closeFacTime.facilityMins}`;
      }
      this.openTimeDisableController = '';
      this.closeTimeDisableController = '';
    }
    this.operationHoursValidation();
  }

  getCurrentCloseTime(time: string) {
    this.closeFacTime.facilityHours = parseInt(time.toString().split(':')[0]);
    this.closeFacTime.facilityMins = parseInt(time.toString().split(':')[1]);
    this.closeTime = time;
    this.operationHoursValidation();
  }

  operationHoursValidation() {
    this.facilityOperationHourBefore = false;
    this.facilityOperationHourSame = false;


    let _closeH = parseInt(this.closeTime ? this.closeTime.split(':')[0] : '0', 10),
      _closeM = parseInt(this.closeTime ? this.closeTime.split(':')[1] : '0', 10),
      _openH = parseInt(this.openTime ? this.openTime.split(':')[0] : '0', 10),
      _openM = parseInt(this.openTime ? this.openTime.split(':')[1] : '0', 10);

    if (_openH == _closeH) {
      if (_openM == _closeM) {
        this.facilityOperationHourSame = true;
      } else if (_openM > _closeM) {
        this.facilityOperationHourBefore = true;
      }
    } else if (_openH > _closeH) {
      this.facilityOperationHourBefore = true;
    }
    this.step3data = { language: this.widgetLanguage, openTime: this.openTime, closeTime: this.closeTime };
    this.step3details.emit(this.step3data);
    return (this.facilityOperationHourBefore || this.facilityOperationHourSame);
  }
  getWidgetlanguage(language: string) {
    this.widgetLanguage = language;
    this.operationHoursValidation();
  }
  // sendToValidate() {
  //   const now = new Date();
  //   if (this.openTime === undefined) {
  //     this.openTime = ('0' + this.openFacTime.facilityHours).slice(-2) + ':' + ('0' + this.openFacTime.facilityMins).slice(-2);
  //   }
  //   if (this.closeTime === undefined) {
  //     this.closeTime = ('0' + this.closeFacTime.facilityHours).slice(-2) + ':' + ('0' + this.closeFacTime.facilityMins).slice(-2);
  //   }
  //   this.step3data = { language: this.widgetLanguage, openTime: this.openTime, closeTime: this.closeTime };
  //   this.step3details.emit(this.step3data);


  // }
}
